module.exports = __webpack_public_path__ + "d745dbf689cb68ea2da4def592bfb4ab.svg";